import { useCallback } from 'react';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, selectQuery } from '../redux/selectionSlice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectQueryRow = ({
  rowIds,
  columnCount,
  totalRowCount,
  CustomSelectAllComponent
}) => {
  const dispatch = useTableDispatch();
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const selectEverything = useCallback(() => dispatch(selectQuery()), [dispatch]);
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  return /*#__PURE__*/_jsxs("tr", {
    "data-row-type": "select-query-row",
    "data-test-id": "select-query-row",
    children: [/*#__PURE__*/_jsx("td", {
      "data-cell-type": "select-query",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        paddingInlineStart: "1700",
        children: isQuerySelected ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "datatable.bulkActions.querySelected",
            options: {
              count: totalRowCount
            }
          }), /*#__PURE__*/_jsx(Button, {
            "data-test-id": "clear-selection-button",
            use: "link",
            onClick: clearAllSelections,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "datatable.bulkActions.clearSelection"
            })
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "datatable.bulkActions.pageSelected",
            options: {
              count: rowIds.length
            }
          }), /*#__PURE__*/_jsx(CustomSelectAllComponent, {
            selectEverything: selectEverything,
            totalRowCount: totalRowCount
          })]
        })
      })
    }), /*#__PURE__*/_jsx("td", {
      colSpan: columnCount - 1
    })]
  });
};
export default SelectQueryRow;